export function getFilterMeals(meal, mealId, segmentId) {
    return meal
        .filter(item => item.segmentId === segmentId && item.mealId === mealId)
        .map(item => ({ passengerId: item.passengerId, count: item.count }));
}
